<template>
  <div>
    <div v-if="!loading">
      <table-cadu
        v-model="selected"
        custom
        disabledCheckAll
        nameTab="historicoPerfil"
        :showFiltro="false"
        :loading="loading"
        :class="$vuetify.breakpoint.xs ? 'competencia-mobile' : 'competencia'"
        :rows="rows"
        :rowsHeader="rowsHeader"
        :elementsPerPageProp="elementsPerPage"
        :items="['05', '10', '15']"
        :qtResultados="qtResultados"
        :qtPaginas="qtPaginas"
        :pagina="pagina"
        :showCheck="false"
        :editar="canEdit && opcaoEditar == 'true'"
        :disabledButtons="[true, true, false]"
        :ordemProp="dirOrdem"
        :role="role"
        larguraUltimoHeader="250"
        @change-element="(element) => changeSelect(element)"
        @change-page="(page) => changePage(page.currentPage)"
        @ordena="(ordem) => changeOrdem(ordem)"
        @clickButton="clickButton"
      />
    </div>
    <component-loading :value="loading" />
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import Beneficiario from '@/services/Perfil/Beneficiario'
import Cooperado from '@/services/Perfil/Cooperado'
import Colaborador from '@/services/Perfil/Colaborador'

export default {
  props: {
    competencia: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      selected: [],
      rows: [],
      rowsHeader: [
        { text: 'Competência', icon: 'repeat' },
        { text: 'Última atualização', icon: 'repeat' },
        { text: 'Usuário', icon: 'repeat' }
      ],
      qtResultados: 5,
      pagina: 1,
      qtPaginas: 1,
      hoverIndex: -1,
      showButton: false,
      role: '',
      tokenBearer: '',
      opcaoEditar: false,
      tipoOrdem: 'competencia',
      dirOrdem: 'desc',
      loading: false,
      elementsPerPage: '05',
      type: '',
      editLast: []
    }
  },
  beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    this.opcaoEditar = localStorage.getItem('optionEdit')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role
  },
  computed: {
    canEdit() {
      return this.role === 'admin_brasil' || this.role === 'admin' || this.role === 'dirigente'
    },
    args() {
      return `ordenacao=${this.tipoOrdem}&direcaoOrdenacao=${this.dirOrdem}&tamanhoPagina=${this.elementsPerPage}&pagina=${this.pagina}`
    },
    argsWithCompetencia() {
      return `${this.args}&competencia=${this.competencia}`
    }
  },
  methods: {
    setCampoOrdenado(index) {
      if(this.type === 0 && index == 2) {
        this.tipoOrdem = 'tipoAtualizacao';
        return;
      } else if (this.type === 0 && index == 3) {
        this.tipoOrdem = 'usuarioAtualizacao.nome';
        return;
      }

      switch (index) {
        case 0:
          this.tipoOrdem = 'competencia'
          break
        case 1:
          this.tipoOrdem = 'dataAtualizacao'
          break
        case 2:
          this.tipoOrdem = 'usuarioAtualizacao.nome'
          break
        case 3:
          this.tipoOrdem = 'tipoAtualizacao'
          break
        default:
          this.tipoOrdem = ''
          break
      }
    },
    async filterByCompetencia() {
      this.pagina = 1
      this.loading = true
      await this.getTable(this.argsWithCompetencia)
      this.loading = false
    },
    async start(type) {
      this.loading = true
      this.clean()
      this.type = type
      await this.getTable(this.args)
      this.loading = false
    },
    async selectTable(args) {
      let cooperado = new Cooperado(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
      let beneficiario = new Beneficiario(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
      let colaborador = new Colaborador(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
      let res = ''
      switch (this.type) {
        case 0:
          res = await beneficiario.getBeneficiarios(args)
          break
        case 1:
          res = await cooperado.getCooperados(args)
          break
        case 2:
          res = await colaborador.getColaboradores(args)
          break
        default:
          break
      }
      return res
    },
    clean() {
      this.qtResultados = 5
      this.pagina = 1
      this.elementsPerPage = 5
    },
    async getTable(args) {
      try {
        let responseGet = await this.selectTable(args)
        responseGet = responseGet.data
            
        this.pagina = responseGet.pagina
        this.qtResultados = responseGet.qtResultados
        this.qtPaginas = responseGet.qtPaginas;
        this.rows = responseGet.conteudo;

        if (this.type == 0) {
          this.addBeneficiarioCustomTableHeader();
        }

        this.rows.forEach(unimedRow => {
          Object.assign(unimedRow, { indexType: this.type });
        });

        this.rows.map((row) => {
          if (this.isEditable(row)) {
            row.editavel = true;
          } else {
            row.editavel = false;
          }
        })
        this.rows.forEach((el) => this.editLast.push(el.editavel));

      } catch (err) {
        console.error(err)
        if (err.response.status === 400) {
          this.$emit('errorFiltro')
        } else {
          this.$emit('error', err.response)
        }
      }
    },
    addBeneficiarioCustomTableHeader() {
      this.rowsHeader = [
        { text: 'Competência', icon: 'repeat' },
        { text: 'Última atualização', icon: 'repeat' },
        { text: 'Tipo de atualização', icon: 'repeat' },
        { text: 'Usuário', icon: 'repeat' }
      ];
    },
    async changeSelect(element) {
      if (element !== this.rows.length && this.pagina < this.qtPaginas) {
        this.elementsPerPage = element
        this.loading = true
        if (this.competencia) {
          await this.getTable(this.argsWithCompetencia)
        } else {
          await this.getTable(this.args)
        }
        this.loading = false
      } else {
        this.pagina = 1
        this.elementsPerPage = element
        this.loading = true
        if (this.competencia) {
          await this.getTable(this.argsWithCompetencia)
        } else {
          await this.getTable(this.args)
        }
        this.loading = false
      }
    },
    async changePage(page) {
      this.pagina = page
      this.loading = true
      await this.getTable(this.args)
      this.loading = false
    },
    isEditable(row) {
      /** Define regra para permitir edição de competência */
      const competencia = this.convertCompetencia(row.competencia)
      const allowedCompetencias = ['2022-09', '2022-10', '2022-11'];

      if(competencia > '2022-12' && (this.role === 'admin_brasil' || this.role === 'admin')) {
        return true;
      }

      if (this.role === 'admin_brasil' && competencia < '2022-12') {
        return true;
      } else if (this.role === 'admin' || this.role === 'dirigente') {
        if (allowedCompetencias.indexOf(competencia) !== -1) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    clickButton(obj) {
      switch (obj.type) {
        case 'view':
          this.$emit('clickButton', { type: 'view', row: this.rows[obj.index] })
          break
        case 'edit':
          this.$emit('clickButton', { type: 'edit', row: this.rows[obj.index] })
          break
        default:
          break
      }
    },
    getThreeLastMonths() {
      var allowedsMoths = []
      var totalMonths = 3

      for (var i = 1; i <= totalMonths; i++) {
        var date = new Date()
        date.setMonth(date.getMonth() - i)
        var dt = this.formatDateCompetencia(date, 'yyyy-MM')
        allowedsMoths.push(dt)
      }
      return allowedsMoths
    },
    convertCompetencia(text) {
      if (!text) {
        return text
      } else {
        let competencia = text.split('/')
        return `${competencia[1]}-${competencia[0]}`
      }
    },
    formatDateCompetencia(x, y) {
      var z = {
        M: x.getMonth() + 1,
        d: x.getDate(),
        h: x.getHours(),
        m: x.getMinutes(),
        s: x.getSeconds()
      }
      y = y.replace(/(M+|d+|h+|m+|s+)/g, function (v) {
        return ((v.length > 1 ? '0' : '') + z[v.slice(-1)]).slice(-2)
      })

      return y.replace(/(y+)/g, function (v) {
        return x.getFullYear().toString().slice(-v.length)
      })
    },
    async changeOrdem(obj) {
      this.setCampoOrdenado(obj.index)
      this.dirOrdem = obj.ordem
      this.loading = true
      await this.getTable(this.args)
      this.loading = false
    },
    hoverRow(index) {
      this.showButton = true
      this.hoverIndex = index
    },
    downRow() {
      this.hoverIndex = -100
      this.showButton = false
    }
  }
}
</script>

<style lang="sass">
.competencia-mobile > .table-cadu
  padding: 20px 10px !important
  border: none
  border-radius: 0px
  width: 100% !important

.competencia > .table-cadu
  border: none
  border-radius: 0px
  width: 100% !important

.competencia > .table-cadu > .table
  tbody
    tr
      td
        &:last-child
          width: 400px
  table
    width: 100% !important

.competencia-mobile > .table-cadu > .table > table
  width: 100% !important
</style>
